
import {Buffer} from 'buffer';

import {Images} from './query';

export const decode = (
	image: Images['images']['0'],
	callback: (
		x: number,
		y: number,
		value: number,
	) => void,
) => {
	const buf = Buffer.from(image.values, 'base64');
	const arr = new Uint16Array(buf.buffer);
	const max = (2 << 15);

	let index = 0;
	for (let y = 0; y < image.height; y++) {
		for (let x = 0; x < image.width; x++) {
			callback(x, y, arr[index++] / max);
		}
	}
};
